/** Beets stS — paginated user-withdraw enumeration + delay constant.
 *  Address on chain 146: `0xe5da20f15420ad15de0fa650600afc998bbe3955`. */
export const BeetsStSWithdrawalAbi = [
  {
    name: 'getUserWithdraws',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'skip' },
      { type: 'uint256', name: 'maxSize' },
      { type: 'bool', name: 'reverseOrder' },
    ],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint8', name: 'kind' },
          { type: 'uint256', name: 'validatorId' },
          { type: 'uint256', name: 'assetAmount' },
          { type: 'bool', name: 'isWithdrawn' },
          { type: 'uint256', name: 'requestTimestamp' },
          { type: 'address', name: 'user' },
        ],
      },
    ],
  },
  {
    name: 'withdrawDelay',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
